<div>

  <app-app-dashboard-navigation></app-app-dashboard-navigation>

  <div class="dash-section m-5 p-3 bg-white">
    <div class="m-4">
      <div class="col font-weight-bold text-black-50 ">
        Smart Diagnosis/{{ type }}
      </div>
    </div>
  </div>

  <!-- <app-post-diagnosis-modal [category]="category" (reloadDiagnosisEvent)="refreshDiagnosisList()">
  </app-post-diagnosis-modal> -->

  <div class="dash-section m-5 bg-white">
    <div class="col  ">
      <div class="row dash-section px-5 ">
        <div class="col p-2">
          <h3 class="mt-4 py-3 float-left">Smart Diagnosis/{{ type }}</h3>
          <button class="float-right btn background text-white my-3 mt-5 mr-2" data-toggle="modal"
            data-target="#agroModal">
            <i class="fas fa-plus mr-2"></i>Add Diagnosis Information
          </button>
        </div>
      </div>
      <div class="row dash-section px-5">
        <div class="container">
          <p-table #diagnosisT
          [value]="data"
          [paginator]="true"
          [rows]="10"
          [loading]="loading"
          [rowsPerPageOptions]="[10,20,30,40,50]"
          class="table table-striped table-hover"
          >
          <!-- <table class="table table-striped table-hover"> -->
            <!-- <thead class="table_head"> -->
              <ng-template pTemplate="caption"  >
                <div class="row" style="width: 100%;">
                  <div class="col-sm-4 ui-g ui-fluid">
                    <!-- <i class="pi pi-search" style="margin:4px 4px 0 0"></i> -->
                    <div class="ui-g-12 ui-md-12">
                      <h6>Crop</h6>
                      <p-multiSelect
                      id="selectcrop"
                      #selectcrop="ngModel"
                      [(ngModel)]="selectedCrops"
                      [options]="selectCrop"
                      defaultLabel="All"
                      (onChange)="diagnosisT.filter($event.value, 'crop', 'in')">
                      </p-multiSelect>
                    </div>


                  </div>
                  <div class="col-sm-4 ui-g ui-fluid">
                    <!-- <i class="pi pi-search" style="margin:4px 4px 0 0"></i> -->
                    <div class="ui-g-12 ui-md-12">
                      <h6>{{ type }}</h6>
                      <p-multiSelect
                      id="nameselect"
                      #nameselect="ngModel"
                      [(ngModel)]="selectedName"
                      [options]="namesToSelect"
                      defaultLabel="All"
                      (onChange)="diagnosisT.filter($event.value, 'name', 'in')">
                      </p-multiSelect>
                    </div>


                  </div>
                  <div class="col-sm-4">
                    <p>&nbsp;</p>
                    <button
                    (click)="Clear(diagnosisT)"

                    style="float: right;"
                    class="btn btn-md bg-dark disabled text-white clear"
                    >
                    Clear Filters
                    </button>
                  </div>

                </div>
            </ng-template>
            <ng-template pTemplate="header" class="table_head">
              <tr>
                <th scope="col" style="width: 40px; background-color: rgb(89, 170, 233);color: white;">#</th>
                <th scope="col" *ngIf="type === 'Diseases'" style="background-color: rgb(89, 170, 233);color: white;">
                  Disease Name
                </th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;" *ngIf="type === 'Pests'">Pest Name</th>

                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Image</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Crop</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Affected Part</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;" *ngIf="type === 'Diseases'">Symptoms</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;" *ngIf="type === 'Pests'">Effects</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Assigned Weight</th>


                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td> {{ data.indexOf(row)+1 }}</td>
                <td>{{ row.name }}</td>
                <td><img src='{{ "https://storage.googleapis.com/ezyagric-media" + row.photo_url }}' width="80" height="80" alt="{{category}} image"
                    *ngIf="row.photo_url" />
                  {{ !row.photo_url ? 'N/A' : '' }}</td>
                <td>{{ row.crop }}</td>
                <td>{{ row.parts }}</td>
                <td [innerHTML]="row.explanation | truncateText:5" class="text"></td>
                <td>{{ row.weight }}</td>

                <td>
                  <div class="dropdown">
                    <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="clearMessage()">
                      ACTION
                    </button>
                    <div class="dropdown-menu options" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" data-toggle="modal" data-target="#viewModal"
                        (click)="setDiagnosisView(row)">View
                      </a>
                      <a class="dropdown-item" data-toggle="modal" data-target="#editSmartModal"
                        (click)="setDiagnosisAction(row)">
                        Edit/Delete
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
            <ng-template #spinnerDiv>
              <tbody>
                <tr>
                  <td colspan="8">
                    <div class="spinner d-flex">
                      <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </ng-template>
        </div>
      </div>
    </div>
    <div class="m-4">&nbsp;</div>
  </div>
  <div class="m-4">&nbsp;</div>
  <!--Add smart diagnosis-->

  <div class="modal fade" id="agroModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Add Smart Diagnosis Data</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="createAgroInfoisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">Diagnosis data added successfully</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetModal()">OK</button>
          </div>

          <div class="modal-body agronomical-view-details" *ngIf="!createAgroInfoisSuccess">
            <span class="text-center alert alert-danger" *ngIf="serverError">{{ message }}</span>
            <div class="container-fluid">
              <form
              *ngIf="crops; else divSpinner"
              #createDiagnosisForm="ngForm"
              (submit)="handleSubmit(createDiagnosisForm.value)"
              id="diagnosisForm"
            >

              <div class="form-group">
                <label for="diagnosisCrop">Select Crop</label>
                <select
                  class="form-control form-control"
                  id="diagnosisCrop"
                  name="crop"
                  #crop="ngModel"
                  ngModel
                  (change)="getDisease()"
                  required
                >
                  <option *ngFor="let cropItem of crops.data" class="crop">
                    {{ cropItem.crop }}
                  </option>
                </select>
                <div
                  *ngIf="crop.touched && !crop.valid"
                  class="error_message"
                >
                  <span *ngIf="crop.hasError('required')">
                    Please Select a crop
                  </span>
                </div>
              </div>

              <div class="form-group">
                <label for="diagnosisName">{{ category | titlecase }} name</label>
                <select
                  class="form-control form-control"
                  id="diagnosisName"
                  name="name"
                  #name="ngModel"
                  ngModel
                  required
                >
                  <option *ngFor="let diseaseItem of selectDisease" class="form-control">
                    {{ diseaseItem.name }}
                  </option>
                </select>
              </div>

              <!-- <div class="form-group">
                <label for="diagnosisNSelector">Select part to handle</label>
                <select
                  class="form-control form-control"
                  id="diagnosisSelector"
                  name="selector"
                  #selector="ngModel"
                  ngModel
                  (change)="partToHandle()"
                  required
                >
                  <option class="form-control">
                    parts
                  </option>
                  <option class="form-control">
                    pest
                  </option>
                </select>
              </div> -->

              <div class="form-group">
                <label for="diagnosisPart">Part</label>
                <!-- <input
                  type="text"
                  class="form-control"
                  id="diagnosisPart"
                  aria-describedby="partHelp"
                  name="part"
                  #part="ngModel"
                  ngModel
                  (keyup)="partToHandle()"
                  required
                /> -->
                <select
                    class="form-control form-control"
                    name="part"
                    id="diagnosisPart"
                    #part="ngModel"
                    ngModel
                    (change)="partToHandle()"
                    required
                  >
                    <option *ngFor="let part of parts" class="form-control" value="{{part}}">
                      {{ part }}
                    </option>
                  </select>
              </div>


              <div class="from-group">
                <label for="diagnosisExplanation" id="diagnosisExpLabel">{{ explanationTitle | titlecase }}</label>
                <textarea type="text" id="diagnosisExplanation" class="form-control md-textarea" #explanation="ngModel" ngModel placeholder="Symptoms" name="explanation"
                  ></textarea>
                <!-- <quill-editor
                  id="diagnosisExplanation"
                  [modules]="quillConfig"
                  name="explanation"
                  #explanation="ngModel"
                  [(ngModel)]="model.explanation"
                  (onEditorChanged)="clearErrorMessage(explanation)"
                >
                </quill-editor> -->
                <div
                  *ngIf="requiredField.explanation"
                  class="error_message"
                >
                  Please the {{ explanationTitle }} field is required
                </div>
              </div>


              <!-- <div class="from-group" *ngIf="selector === 'pest'">
                <label for="diagnosisAppearance">Appearance</label>
                <quill-editor
                  id="diagnosisAppearance"
                  [modules]="quillConfig"
                  name="appearance"
                  #appearance="ngModel"
                  [(ngModel)]="model.appearance"
                  (onEditorChanged)="clearErrorMessage(appearance)"
                >
                </quill-editor>
                <div
                  *ngIf="requiredField.explanation"
                  class="error_message"
                >
                  Please the Appearance field is required
                </div>
              </div> -->

              <div class="form-group">
                <label for="diagnosisWeight">Weight</label>
                <input
                  type="number"
                  class="form-control"
                  id="diagnosisWeight"
                  aria-describedby="weightHelp"
                  name="weight"
                  #weight="ngModel"
                  ngModel
                  required
                />
              </div>

              <div class="form-group">
                <label for="diagnosisPhoto">Image</label>
                <input
                  type="file"
                  class="form-control"
                  id="diagnosisPhoto"
                  name="photo"
                  (change)="changeImage($event)"
                />
              </div>

              <div class="my-3 d-flex flex-row-reverse">
                <button
                  type="button"
                  class="btn btn-secondary ml-3"
                  data-dismiss="modal"
                  (click)="closeModal()"
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  class="btn button-color text-white"
                  [disabled]="!createDiagnosisForm.form.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                  SAVE INFO
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!createAgroInfoisSuccess">
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- View diagnosis modal -->
  <div class="modal fade" id="viewModal" tabindex="-1" role="dialog" aria-labelledby="viewDiagnosisModalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 60%;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-color" id="viewDiagnosisModalTitle">{{ category | titlecase }} Details</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="container-fluid" *ngIf="diagnosisViewData">
            <div class="row">
              <div class="col-4">
                <div>
                  <img src='{{ "https://storage.googleapis.com/ezyagric-media" + diagnosisViewData.photo_url }}' alt="diagnosisViewData.activity" class="img-fluid"
                    *ngIf="diagnosisViewData.photo_url" />
                </div>
              </div>
              <div class="col-8">
                <div>
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <th scope="row">{{ category | titlecase }} Name:</th>
                        <td>{{ diagnosisViewData.name }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Crop:</th>
                        <td>{{ diagnosisViewData.crop }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Affected Part:</th>
                        <td>{{ diagnosisViewData.parts }}</td>
                      </tr>
                      <tr>
                        <th scope="row">Symptoms:</th>
                        <td [innerHTML]="diagnosisViewData.explanation"></td>
                      </tr>
                      <tr>
                        <th scope="row">Assigned Weight:</th>
                        <td>{{ diagnosisViewData.weight }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete modal -->
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteDiagnosisModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" *ngIf="diagnosisDeleteData">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteDiagnosisModal">Delete {{ category | titlecase }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body" *ngIf="!deleteDiagnosisloading && !message">
          <span class="text-center" *ngIf="message">{{ message }}</span>
          Are you sure you want to delete <span class="font-weight-bold">{{ diagnosisDeleteData.name }}</span>
        </div>
        <div class="modal-body" *ngIf="message">
          <span class="text-center">{{ message }}</span>
        </div>
        <div class="spinner d-flex" *ngIf="deleteDiagnosisloading">
          <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
        </div>
        <div class="modal-footer" *ngIf="!deleteDiagnosisloading">
          <button type="button" class="btn btn-danger" (click)="deleteDiagnosis(diagnosisDeleteData.id)"
            *ngIf="!message">Delete {{ category | titlecase }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" *ngIf="!message">Close</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="resetDeleteModal()" *ngIf="message">Ok
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--Edit smart diagnosis data-->
  <div class="modal fade" id="editSmartModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Edit Details</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="editSmartInfoisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">Smart diagnosis data edited successfully</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetEditModal()">OK</button>
          </div>

          <div class="modal-body agronomical-view-details" *ngIf="!editSmartInfoisSuccess">
            <span class="text-center alert alert-danger" *ngIf="editError">{{ message }}</span>
            <div class="container-fluid" *ngIf="editInfoData">
              <form *ngIf="editInfoData" (submit)="handleEdit(updateSmartForm.value, editInfoData.id)" #updateSmartForm="ngForm"
              class="px-2 py-2">
              <div class="form-group">
                <label for="crop">Name of Crop</label>
                <!-- <input type="text" class="form-control change-input-field" placeholder="name of crop" name="crop"
                  value="{{ editInfoData.crop }}" #crop="ngModel" [(ngModel)]="editInfoData.crop" minlength="3" /> -->
                  <select
                    class="form-control form-control"
                    id="selectedCrop"
                    name="crop"
                    #crop="ngModel"
                    ngModel
                    [(ngModel)]="editInfoData.crop"
                    (change)="getEditDisease()"
                    required
                  >
                    <option selected>{{editInfoData.crop}}</option>
                    <option *ngFor="let cropItem of crops.data" class="crop">
                      {{ cropItem.crop }}
                    </option>
                  </select>
              </div>
              <div class="form-group">
                <label for="disease">Disease</label>
                <!-- <input type="text" class="form-control change-input-field" #disease="ngModel" [(ngModel)]="editInfoData.name"
                 value="{{ editInfoData.name }}" placeholder="disease" name="disease"/> -->
                 <select
                    class="form-control form-control"
                    name="name"
                    #name="ngModel"
                    [(ngModel)]="editInfoData.name"
                    ngModel
                    required
                  >
                    <option selected>{{editInfoData.name}}</option>
                    <option *ngFor="let diseaseItem of selectDisease" class="form-control">
                      {{ diseaseItem.name }}
                    </option>
                  </select>
              </div>
              <div class="form-group">
                <label for="parts">Affected Part</label>
                <!-- <input type="text" class="form-control
                            change-input-field" #parts="ngModel" [(ngModel)]="editInfoData.parts" placeholder="symptoms" value="{{ editInfoData.parts }}" name="parts"/> -->
                <select
                  class="form-control"
                  name="part"
                  #part="ngModel"
                  [(ngModel)]="editInfoData.parts"
                  required
                >
                  <option selected>{{editInfoData.parts}}</option>
                  <option *ngFor="let part of parts" class="form-control">
                    {{ part }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="symptoms">Symptoms</label>
                <textarea type="text" class="form-control md-textarea" #explanation="ngModel" [(ngModel)]="editInfoData.explanation" placeholder="Symptoms" name="explanation"
                  value="{{ editInfoData.explanation }}" ></textarea>
                  <!-- <quill-editor
                    name="explanation"
                    #explanation="ngModel"
                    [(ngModel)]="editInfoData.explanation"
                    [modules]="quillConfig"
                    (onEditorChanged)="clearErrorMessage(explanation)"
                  >
                  </quill-editor> -->
              </div>
              <div class="form-group">
                <label for="weight">Assigned Weight</label>
                <input type="number" class="form-control
                            change-input-field" #weight="ngModel" [(ngModel)]="editInfoData.weight" placeholder="assigned weight" value="{{ editInfoData.weight }}" name="weight" />
              </div>
              <div class="form-group">
                <label for="photo">Image</label>
                <input type="file" value="CHOOSE FILE" name="photo" class="form-control change-files"
                  (change)="changeImage($event)" accept="image/png, image/jpeg, image/jpg" />
              </div>
              <div class="d-flex justify-content-center align-item-center form-group">
                <button type="submit" class="submit-input-btn" >
                  <span *ngIf="loading" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save Info
                  </span>
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!editSmartInfoisSuccess">
            <a
            class="btn btn-danger text-white"
            data-dismiss="modal"
            data-toggle="modal"
            data-target="#deleteModal"
            (click)="deleteInfoDetails( editInfoData )"
            >Delete</a
            >
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
